import { User } from './_models/user';
import { Injectable, OnDestroy } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';
import { Router } from '@angular/router';
import { BehaviorSubject, Subject, Observable } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';

const helper = new JwtHelperService();

export abstract class BaseAuthService {
  destroy$: Subject<boolean> = new Subject<boolean>();
  checkChangePasswordRequired = true;
  sessionStorageTokenName = 'token';
  meUrl;
  meObs = new BehaviorSubject<any>(null);
  me$ = this.meObs.asObservable();

  meSubscribe;

  emailHelper;

  // ngOnDestroy() {
  //   // Unsubscribe from whatever used takeUntil(destroy$)
  //   this.destroy$.next(true);
  //   // Now let's also unsubscribe from the subject itself:
  //   this.destroy$.unsubscribe();
  // }

  get me() {
    const iCurrentUser = this.meObs.getValue();
    if (iCurrentUser === null) {
      return this.meObs.getValue();
    } else {
      return iCurrentUser;
    }
  }

  public get currentUser() {
    return this.meObs.value;
  }

  constructor(public router?, public dataService?) {}

  setToken(token, returnUrl, email?, callback?) {
    sessionStorage.setItem(this.sessionStorageTokenName, token);
    const decodedToken = helper.decodeToken(token);
    if (decodedToken.require_password_update) {
      this.emailHelper = email;
      this.router.navigate(['/auth/change-password']);
    } else {
      this.router.navigate([returnUrl]);
    }

    if (callback) {
      callback();
    }
  }

  getToken() {
    return sessionStorage.getItem(this.sessionStorageTokenName);
  }

  isAuthenticated() {
    if (typeof sessionStorage !== 'undefined') {
      const token = sessionStorage.getItem(this.sessionStorageTokenName);
      const isExpired = helper.isTokenExpired(token);
      return !isExpired;
    } else {
      return false;
    }
  }

  removeToken(redirectUrl, redirect = true) {
    this.meObs.next(null);
    if (this.meSubscribe) {
      this.meSubscribe.unsubscribe();
    }
    sessionStorage.removeItem(this.sessionStorageTokenName);
    if (redirect) {
      setTimeout(() => {
        this.router.navigate([redirectUrl]);
      });
    }
  }

  getData(callback?) {
    this.meSubscribe = this.dataService.invoke(this.meUrl).subscribe((res) => {
      this.meObs.next(res);
      if (callback) {
        callback();
      }
    });
  }

  async getMe(callback?) {
    await this.getMeRequest().subscribe((res: User) => {
      const user = res as User;
      // console.log(user);
      this.meObs.next(res);
      if (res.require_password_update) {
        this.router.navigate(['/biznes/zmien-haslo']);
      }
      if (callback) {
        callback();
      }
    });
  }

  public getMeRequest(): Observable<any> {
    return this.dataService.invoke(this.meUrl).pipe(takeUntil(this.destroy$));
  }
}
